'use strict';

angular.module('licensure.services')
    .factory('CensusTracts', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/censustracts', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        d.reject(response.data);
                    });

                return d.promise;
            }
        }
    }])
;